export default "__VITE_ASSET__xBX3r0VK__"